<template>
  <div>
    <div class="notifications-container" @click="ToggleNotifications">
      <span class="notifications">
        {{ notifications.length }}
        <img src="https://storage.googleapis.com/wp-bucket-tcc/channel/images/bell-notification.svg" alt="bell-notify">
      </span>
    </div>

    <div class="overlay-notifications">
      <div class="close-notify-panel-mobile" @click="closeOverlay">
        <img src="https://storage.googleapis.com/wp-bucket-tcc/channel/images/close-big.svg" alt="close">
      </div>
      <div class="container-cards">
        <NotificationCard 
          v-for="(notification, i) in notifications"
          :documentNumber="clientDocumentNumber"
          :id="notification.id"
          :title="notification.title"
          :message="notification.message"
          :data="notification.data"
          @closeOverlay="closeOverlay"
          :key="i"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import NotificationCard from '@/components/NotificationsMenu/NotificationCard.vue';
  
  export default {
    props: ['optionMenu', 'notifications'],
    inject: ['clientDocumentNumber'],
    components: {NotificationCard},
    data: () => ({
      father: "",
      notifyContainers: ""
    }),
    methods:{
      ToggleNotifications(e){
        this.notifyContainers = [...document.querySelectorAll(".notifications-container")];
        this.father = e.target.closest(".notifications-container");

        this.notifyContainers.forEach(element => {
          if(element == this.father) {
            this.father.classList.toggle('open')
            return
          }
          element.classList.remove('open')
        });
      },
      closeOverlay() {
        this.father.classList.remove('open')
      }
    }
  }
</script>


<style scoped lang="scss">
  @import "@/scss/menu/notifications.scss";
</style>